/**
 * Newsroom Live — live workspace-scoped editorial activity feed.
 *
 * Lets the Newsroom Live surface render a Bloomberg-terminal style live view
 * of what every Desk editor (and run/approval/press) is doing in the
 * workspace right now. Activities are produced by:
 *   - runDeskTurn.ts — per Desk turn (started / noop / story_drafted / error)
 *   - Approval flow — pending action raised or resolved
 *   - Press shipments — completion tool executed
 *   - Wire heartbeat — ambient activity on idle so empty workspaces still feel alive
 *
 * All payloads are display-ready (summary is human-readable, never raw IDs).
 * Workspace isolation is enforced by the backend: a NewsroomActivity is only
 * broadcast to subscribers whose socketContext.workspaceId matches the
 * activity's workspaceId.
 */
export const NEWSROOM_ACTIVITY_KINDS = [
    "desk_turn.started",
    "desk_turn.noop",
    "desk_turn.story_drafted",
    "desk_turn.error",
    "desk_turn.tool_called",
    "desk_turn.stance_changed",
    "run.started",
    "run.completed",
    "run.failed",
    "approval.requested",
    "approval.resolved",
    "story.published",
    "press.shipped",
    "wire.heartbeat",
];
/**
 * The ordered section keys of a {@link DeskBriefContent}, paired with their
 * display labels. Shared so the backend validator and the frontend renderer
 * agree on order + labels without duplicating the list.
 */
export const DESK_BRIEF_SECTIONS = [
    { key: "mandate", label: "Responsibilities" },
    { key: "success", label: "What success looks like" },
    { key: "whatToWatch", label: "What to watch" },
    { key: "guardrails", label: "Guardrails" },
    { key: "keyPeople", label: "Key people and accounts" },
    { key: "voice", label: "Voice" },
];
/**
 * The Team line-icon vocabulary — the user-choosable flat glyphs shown next to
 * a Team in the sidebar rail and pickable in Team settings. Shared so the
 * charter PATCH validator and the frontend `TeamIcon` renderer agree on the
 * set. `desks.icon` stores one of these names, or NULL for the derived
 * default (keyword match on the team name).
 */
export const TEAM_ICON_NAMES = [
    "shield",
    "cart",
    "trend",
    "chat",
    "wrench",
    "flask",
    "megaphone",
    "book",
    "globe",
    "bolt",
    "target",
    "users",
    "pen",
    "compass",
    "heart",
];
export function isTeamIconName(value) {
    return (typeof value === "string" && TEAM_ICON_NAMES.includes(value));
}
//# sourceMappingURL=newsroomLive.js.map